export { default as Img200 } from './processed/200/Hitcher-The-landscape.jpg';
export { default as Img400 } from './processed/400/Hitcher-The-landscape.jpg';
export { default as Imgthumb } from './processed/thumb/Hitcher-The-landscape.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Hitcher-The-landscape.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Hitcher-The-landscape.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      201,
      21,
      27
    ],
    "_population": 112,
    "_hsl": [
      0.9944444444444445,
      0.8108108108108107,
      0.43529411764705883
    ]
  },
  "LightVibrant": {
    "_rgb": [
      222,
      145,
      98
    ],
    "_population": 241,
    "_hsl": [
      0.06317204301075267,
      0.6526315789473685,
      0.6274509803921569
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      115,
      30,
      16
    ],
    "_population": 1506,
    "_hsl": [
      0.02356902356902357,
      0.7557251908396947,
      0.2568627450980392
    ]
  },
  "Muted": {
    "_rgb": [
      91,
      147,
      164
    ],
    "_population": 203,
    "_hsl": [
      0.5388127853881279,
      0.2862745098039216,
      0.5
    ]
  },
  "LightMuted": {
    "_rgb": [
      164,
      213,
      214
    ],
    "_population": 71,
    "_hsl": [
      0.5033333333333333,
      0.37878787878787884,
      0.7411764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      82,
      68,
      44
    ],
    "_population": 4,
    "_hsl": [
      0.10526315789473682,
      0.3015873015873016,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Hitcher-The-landscape.js